// extracted by mini-css-extract-plugin
export default {"headerItem":"styles_headerItem__8dxZh"};